import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  MoneyDto,
  ProjectDto,
  RowDto,
} from 'services/APIs/InternalAPI/internal-api.contracts'
import { ShowException } from 'store/Application/appActions'
import { newProjectActions } from '../newProjectReducer'
import { projectAPIBuilder } from './BoMAsyncActions'
import { fetchProject } from './fetchProject'

export const saveBomItemTargetPrice = createAsyncThunk<
  any,
  any,
  { state: any }
>(
  'bomItem/saveBomItemTargetPrice',
  async (
    { bomItemId, targetPrice }: { bomItemId: string; targetPrice: MoneyDto },
    thunkAPI
  ) => {
    const { api, projectId } = projectAPIBuilder(thunkAPI.getState)

    try {
      thunkAPI.dispatch(
        newProjectActions.setBomItemProperties({
          id: bomItemId,
          financial: {
            targetSalesPricePerItem: targetPrice,
          },
        } as RowDto | ProjectDto)
      )

      await api.SetTargetPrice(projectId, bomItemId, targetPrice)
    } catch (error) {
      ShowException('target price', error)
      thunkAPI.dispatch(fetchProject({ projectId: projectId }))
      throw error
    }
  }
)
